import * as React from 'react';
import type { CustomRouteComponentProps } from 'react-router-dom';

import Breadcrumbs from 'af-components/Breadcrumbs';
import TabNavigation from 'af-components/TabNavigation';

import MaterialGroups from './MaterialGroups';
import MaterialList from './Materials';

type OwnProps = CustomRouteComponentProps;

type Props = OwnProps;

const BREADCRUMBS = [{ label: 'Materials' }];

enum Tabs {
	Materials = 0,
	Groups = 1
}

const TABS = [
	{
		id: Tabs.Materials,
		label: 'Materials',
	},
	{
		id: Tabs.Groups,
		label: 'Material Groups',
	},
];

const MaterialsAndGroups: React.FC<Props> = () => {
	const [activeTabId, setActiveTabId] = React.useState<Tabs>(Tabs.Materials);

	return (
		<div className="form-segment form-segment--maxi">
			<Breadcrumbs items={BREADCRUMBS} />
			<TabNavigation
				active={activeTabId}
				onClick={setActiveTabId}
				tabs={TABS}
			/>
			{activeTabId === Tabs.Materials ? <MaterialList /> : null}
			{activeTabId === Tabs.Groups ? <MaterialGroups /> : null}
		</div>
	);
};

export default React.memo(MaterialsAndGroups);
